module.exports = __webpack_public_path__ + "static/media/london.748525ec.jpeg";